import { ListSubheader, styled } from "@mui/material";

export const StyledListSubheader = styled(ListSubheader)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  padding: theme.spacing(0, 1.5),
  height: "40px",
}));
